'use client'

import { Modal } from '@/components/atoms/Modal'
import Button from '@/components/atoms/Button'
import styles from './ConfirmDeleteFileModal.module.scss'
import { ModalComponentProps } from '@/components/atoms/Modal/ModalContainer'
import Icon from '@/components/atoms/Icon'
import { Heading, Paragraph } from '@/components/atoms/Typography'

// Definiamo una versione specifica per ConfirmModal escludendo isOpen e onClose (gestite internamente dal sistema)
type ConfirmModalSpecificProps = {
  /**
   * Titolo della modale
   */
  title?: string

  /**
   * Callback da eseguire quando l'utente conferma
   */
  onConfirm?: () => void

  /**
   * Testo del pulsante di conferma
   */
  confirmText?: string

  /**
   * Testo del pulsante di annullamento
   */
  cancelText?: string

  /**
   * Tipo di conferma (influisce sul colore del pulsante)
   */
  type?: 'danger' | 'warning' | 'success' | 'info'
}

// Esportiamo il tipo completo che include sia ModalComponentProps che le props specifiche
export type ConfirmModalProps = ModalComponentProps & ConfirmModalSpecificProps

const ConfirmModal = ({
  isOpen,
  onClose,
  title = '',
  onConfirm,
  confirmText = '',
  cancelText = 'Cancel',
}: ConfirmModalProps) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size='sm'
      footer={
        <div className={styles.footer}>
          <Button
            autoWidth
            onClick={handleConfirm}
            variant='primary'
          >
            {confirmText}
          </Button>

          <Button
            autoWidth
            onClick={onClose}
            variant='secondary'
          >
            {cancelText}
          </Button>
        </div>
      }
    >
      <div className={styles.wrapper}>
        <div className={styles.iconContainer}>
          <Icon iconName='AlertTriangle' />
        </div>
        <div className={styles.content}>
          <Heading
            family='serif'
            size='md'
            weight='bold'
          >
            Delete this file?
          </Heading>
          <Paragraph
            family='serif'
            size='md'
          >
            You&apos;re about to permanently remove this file. This be undone.
          </Paragraph>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmModal
